import { combineReducers } from 'redux';

import alerts from './alerts';

const slackData = combineReducers({
  alerts
});

export default slackData;
